import ReduxQuerySync from "redux-query-sync";
import { ROUTE_POINT_TYPES, emptyArray } from "../../constants";
import { parseRouteDirectionQueryString, mapRouteDirectionToQueryString } from "../../utils";
import {
  setRouteQueryParams,
  setRestrictionInitialValue,
  setExcludedCountriesInitialValue,
  setExcludedCitiesInitialValue,
  setShowLightVersion, toggleShowPassingCitiesInRouteDetails,
} from "../actions";
import {defaultRouteRequest} from "../../bl/routeRequestUtils";

const enhancer = ReduxQuerySync.enhancer({
  params: {
    ExcludeCities: {
      selector: state => state.excludedCities,
      valueToString: value => (value.length === 0 ? "" : value.map(city => city.id).join(";")),
      
      stringToValue: str =>
        str
          .split(";")
          .filter(Number)
          .map(id => parseInt(id, 10)),
      action: ids => setExcludedCitiesInitialValue(ids),
      
      defaultValue: emptyArray
    },
    ExcludeCountries: {
      selector: state => state.excludedCountries,
      valueToString: value => (value.length === 0 ? "" : value.map(country => country.id).join(";")),
      
      stringToValue: str =>
        str
          .split(";")
          .filter(Number)
          .map(id => parseInt(id, 10)),
      action: ids => setExcludedCountriesInitialValue(ids),
      
      defaultValue: emptyArray
    },
    City1: {
      selector: () => undefined,
      valueToString: value => value,

      stringToValue: str => parseRouteDirectionQueryString(`${ROUTE_POINT_TYPES.START_POINT}_${str}`),
      action: value =>
        setRouteQueryParams({
          name: "from",
          items: value,
        }),
      defaultValue: undefined
    },
    City5: {
      selector: () => undefined,
      valueToString: value => value,
      
      stringToValue: str => parseRouteDirectionQueryString(`${ROUTE_POINT_TYPES.END_POINT}_${str}`),
      action: value =>
          setRouteQueryParams({
            name: "to",
            items: value,
          }),
      defaultValue: undefined
    },
    Cities: {
      selector: state => state.routeRequest, // возвращает объект, который будет передан в valueToString
      valueToString: value => mapRouteDirectionToQueryString(value),
      
      stringToValue: str => parseRouteDirectionQueryString(str), // возвращает объект, который будет передан в action 
      action: value =>                                           // action creator для сохранения value в store
        setRouteQueryParams({
          name: "through",
          items: value,
        }),
      defaultValue: defaultRouteRequest
    },
    Ferries: {
      selector: state => state.restrictions.allowFerries,
      action: value => {
        const name = "allowFerries";
        return setRestrictionInitialValue({ name, value });
      },
      stringToValue: str => Boolean(Number(str)),
      valueToString: value => (value ? 1 : 0),
      defaultValue: true
    },
    Zimnik: {
      selector: state => state.restrictions.allowWinterRoads,
      action: value => {
        const name = "allowWinterRoads";
        return setRestrictionInitialValue({ name, value });
      },
      stringToValue: str => Boolean(Number(str)),
      valueToString: value => (value ? 1 : 0),
      defaultValue: true
    },
    ExcludeTollRoads: {
      selector: state => state.restrictions.excludeTollRoads,
      action: value => {
        const name = "excludeTollRoads";
        return setRestrictionInitialValue({ name, value });
      },
      stringToValue: str => Boolean(Number(str)),
      valueToString: value => (value ? 1 : 0),
      defaultValue: false
    },
    FastWay: {
      selector: state => state.restrictions.fastWay,
      action: value => {
        const name = "fastWay";
        return setRestrictionInitialValue({ name, value });
      },
      stringToValue: str => Boolean(Number(str)),
      valueToString: value => (value ? 1 : 0),
      defaultValue: true,
    },
    ExcludeMkad: {
      selector: state => state.restrictions.excludeMkad,
      action: value => {
        const name = "excludeMkad";
        return setRestrictionInitialValue({ name, value });
      },
      stringToValue: str => Boolean(Number(str)),
      valueToString: value => (value ? 1 : 0),
      defaultValue: false,
    },
    UseBelarusRule: {
      selector: state => state.restrictions.useBelarusRule,
      action: value => {
        const name = "useBelarusRule";
        return setRestrictionInitialValue({ name, value });
      },
      stringToValue: str => Boolean(Number(str)),
      valueToString: value => (value ? 1 : 0),
      defaultValue: false,
    },
    WithinCountry: {
      selector: state => state.restrictions.withinCountry,
      action: value => {
        const name = "withinCountry";
        return setRestrictionInitialValue({ name, value });
      },
      stringToValue: str => Boolean(Number(str)),
      valueToString: value => (value ? 1 : 0),
      defaultValue: true,
    },
    ShowPassingCities: {
      selector: state => state.showPassingCitiesInRouteDetails,
      action: value => toggleShowPassingCitiesInRouteDetails(value),
      stringToValue: str => Boolean(Number(str)),
      valueToString: value => (value ? 1 : 0),
      defaultValue: false
    },
    LightVersion: {
      selector: state => state.showLightVersion,
      action: value => {
        return setShowLightVersion(value);
      },
      stringToValue: str => Boolean(Number(str)),
      valueToString: value => (value ? 1 : 0),
      defaultValue: false,
    },
    Weight: {
      selector: state => state.restrictions.weight,
      action: value => {
        const name = "weight";
        return setRestrictionInitialValue({ name, value });
      },
      stringToValue: str => Number(str),
      valueToString: value => value.toString(),
      defaultValue: undefined
    }
  },
  initialTruth: "location",
  replaceState: true,
});

export default enhancer;
